namespace RedBullMOBILE360.Sms {
    export interface CampaignEligibilityRow {
        Id?: number;
        OfferId?: string;
        WhitelistId?: number;
        OfferOfferName?: string;
        OfferIsPrimary?: number;
        OfferSubscriptionCode?: string;
        OfferUnsubscriptionCode?: string;
        OfferIsActive?: number;
        OfferStopAtrnwCode?: string;
        WhitelistWhitelistName?: string;
        WhitelistCreationDate?: string;
        WhitelistLastUpdateDate?: string;
        WhitelistCreatedBy?: number;
    }

    export namespace CampaignEligibilityRow {
        export const idProperty = 'Id';
        export const nameProperty = 'OfferId';
        export const localTextPrefix = 'Sms.CampaignEligibility';
        export const deletePermission = 'Sms:CampaignEligibility';
        export const insertPermission = 'Sms:CampaignEligibility';
        export const readPermission = 'Sms:CampaignEligibility';
        export const updatePermission = 'Sms:CampaignEligibility';

        export declare const enum Fields {
            Id = "Id",
            OfferId = "OfferId",
            WhitelistId = "WhitelistId",
            OfferOfferName = "OfferOfferName",
            OfferIsPrimary = "OfferIsPrimary",
            OfferSubscriptionCode = "OfferSubscriptionCode",
            OfferUnsubscriptionCode = "OfferUnsubscriptionCode",
            OfferIsActive = "OfferIsActive",
            OfferStopAtrnwCode = "OfferStopAtrnwCode",
            WhitelistWhitelistName = "WhitelistWhitelistName",
            WhitelistCreationDate = "WhitelistCreationDate",
            WhitelistLastUpdateDate = "WhitelistLastUpdateDate",
            WhitelistCreatedBy = "WhitelistCreatedBy"
        }
    }
}
